window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.error("Error in triggering merchants purchase script : ", e);
  }
}

function merchantPurchaseCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11464706020");
  gtag('set', 'user_data', {
    "email": params.userDetails.email,
    "phone_number": params.userDetails.phone,
    "address": {
        "first_name": params.userDetails.name,
        "city": params.userDetails.city,
        "region": params.userDetails.state,
        "postal_code": params.userDetails.postalCode,
        "country": "IN"
    }
  });

  window.gtag("event", "conversion", {
    send_to: "AW-11464706020/j4mfCJj18c0bEOSP5toq",
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "breeze"
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}